import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import PublicLayout from "../templates/layouts/public/Layout";
import ForbiddenPage from "../views/errors/ForbiddenPage";
import { USER_TYPES } from "../utils/userTypeConstants";
import {
  isStaffPortalDeactivated,
  canStaffUpdateAvailability,
  refreshStaffPortalPermissions,
} from "../utils/authHelper";
import StaffAvailabilityLockedPage from "../views/staff/StaffAvailabilityLockedPage";
import Spinner from "../components/Spinner";

const STAFF_SCHEDULE_PATH = "/staff/schedule";

const PrivatePage = ({ appRoute }) => {
  const isStaffScheduleRoute =
    appRoute.userType === USER_TYPES.staff &&
    appRoute.path === STAFF_SCHEDULE_PATH;

  const [permissionsReady, setPermissionsReady] = useState(!isStaffScheduleRoute);
  const [availabilityAllowed, setAvailabilityAllowed] = useState(
    canStaffUpdateAvailability()
  );

  useEffect(() => {
    if (!isStaffScheduleRoute) {
      return;
    }

    refreshStaffPortalPermissions(() => {
      setAvailabilityAllowed(canStaffUpdateAvailability());
      setPermissionsReady(true);
    });
  }, [isStaffScheduleRoute]);

  if (
    appRoute.userType === USER_TYPES.staff &&
    isStaffPortalDeactivated()
  ) {
    return <Navigate to="/admin/user-type" replace />;
  }

  if (isStaffScheduleRoute && !permissionsReady) {
    return <Spinner />;
  }

  if (isStaffScheduleRoute && !availabilityAllowed) {
    return <StaffAvailabilityLockedPage />;
  }

  if (localStorage.userType && appRoute.userType !== localStorage.userType) {
    return <PublicLayout Component={ForbiddenPage} route={appRoute.path} />;
  }

  const Component = appRoute.component;
  return <Component route={appRoute.path} />;
};

export default PrivatePage;
